const selector = '.timecard-nav__details';

function closeProductMenus(except = null) {
  document.querySelectorAll(`${selector}[open]`).forEach((details) => {
    if (details !== except) details.removeAttribute('open');
  });
}

document.addEventListener('click', (event) => {
  const activeMenu = event.target.closest(selector);
  closeProductMenus(activeMenu);
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeProductMenus();
});

document.addEventListener(
  'toggle',
  (event) => {
    if (event.target.matches(`${selector}[open]`)) closeProductMenus(event.target);
  },
  true
);
